import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { IdStyles } from "../../../less/IdStyles";
import { selectPurchasePointEventRemainingTime, selectPurchasePointsEventInfo, selectPurchasePointsEventRewards, } from "../../../selectors/selectPurchasePointsEventInfo";
import { FarmEventDetailsContainer } from "../../generic/farm-event/FarmEventDetailsContainer";
import { List } from "../../generic/list/List";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { PurchasePointsPackage } from "./PurchasePointsPackage";
var renderPurchasePointsPackage = function (rewardItem, index) { return (React.createElement(PurchasePointsPackage, { key: index, rewardItem: rewardItem })); };
export var _PurchasePointsDetails = function (_a) {
    var purchasePointsRewards = _a.purchasePointsRewards, onCloseClick = _a.onCloseClick, purchasePointsRemainingTime = _a.purchasePointsRemainingTime;
    if (!purchasePointsRewards) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(FarmEventDetailsContainer, { onClose: onCloseClick, remainingTime: purchasePointsRemainingTime },
        React.createElement("div", { className: IdStyles.PurchasePointsEventContainer + " purchase-points__event-details" },
            React.createElement("div", { className: "h100 pr__small" },
                React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "flex flex--guts" },
                    React.createElement(List, { items: purchasePointsRewards, renderItem: renderPurchasePointsPackage, className: "h100" }))))));
};
var mapState = function (state) { return ({
    purchasePointsEventInfo: selectPurchasePointsEventInfo(state),
    purchasePointsRemainingTime: selectPurchasePointEventRemainingTime(state),
    purchasePointsRewards: selectPurchasePointsEventRewards(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCloseClick: function () { return dispatch(actionModalClose(IdModal.PurchasePointsEvent)); },
}); };
export var PurchasePointsDetails = connect(mapState, mapDispatch)(_PurchasePointsDetails);



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/components/PurchasePointsDetails.tsx
// module id = 2886
// module chunks = 3